import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { toast } from "sonner";
import { Eye, Loader2 } from "lucide-react";
import { api, formatApiError } from "@/lib/api";

export function DigestPreview() {
  const [ras, setRas] = useState([]);
  const [uid, setUid] = useState("");
  const [p, setP] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/admin/notifications/region-admins").then((r) => { setRas(r.data); if (r.data[0]) setUid(r.data[0].id); }); }, []);
  const load = () => {
    setBusy(true);
    api.get(`/admin/notifications/digest-preview/${uid}`).then((r) => setP(r.data)).catch((e) => toast.error(formatApiError(e))).finally(() => setBusy(false));
  };
  return (
    <div className="mt-4 w-full rounded-xl border border-lasso-line bg-white p-3" data-testid="digest-preview-card">
      <p className="mb-1 text-xs font-semibold">Preview Region Admin digest</p>
      <p className="mb-2 text-[11px] text-muted-foreground">Renders the expanded weekly digest here. Nothing is sent.</p>
      <div className="flex gap-2">
        <select value={uid} onChange={(e) => setUid(e.target.value)} className="h-9 flex-1 rounded-lg border border-lasso-line px-2 text-sm" data-testid="digest-preview-select">
          {ras.map((r) => <option key={r.id} value={r.id}>{r.name}</option>)}
          {!ras.length && <option value="">No Region Admins</option>}
        </select>
        <button disabled={!uid || busy} onClick={load} className="inline-flex items-center gap-1.5 rounded-lg bg-lasso-ink px-3 text-xs font-semibold text-white disabled:opacity-40" data-testid="digest-preview-button">
          {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Eye className="h-3.5 w-3.5" />} Preview digest
        </button>
      </div>
      {p && createPortal(
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4" onClick={() => setP(null)} data-testid="digest-preview-modal">
          <div className="flex max-h-[92vh] w-full max-w-2xl flex-col overflow-hidden rounded-2xl bg-white" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-start justify-between gap-3 border-b border-lasso-line p-4 text-sm">
              <div><p className="font-semibold" data-testid="digest-preview-subject">{p.subject}</p><p className="text-xs text-zinc-500">To {p.to} · preview only, not sent</p></div>
              <button onClick={() => setP(null)} className="text-zinc-400 hover:text-lasso-ink" data-testid="digest-preview-close">✕</button>
            </div>
            <iframe title="Digest preview" srcDoc={p.html} sandbox="" className="h-[75vh] w-full" data-testid="digest-preview-frame" />
          </div>
        </div>, document.body
      )}
    </div>
  );
}
